import { application } from "./application"

// Eager load all controllers defined in the controllers directory
const context = require.context(".", true, /_controller\.js$/)
application.load(
  context.keys().map((key) => {
    const controllerModule = context(key)
    const controllerName = key
      .replace(/^\.\//, '')
      .replace(/_controller\.js$/, '')
      .replace(/\//g, '--')
    return {
      identifier: controllerName,
      controllerConstructor: controllerModule.default
    }
  })
)
